import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=9dde1226&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&lang=js"
export * from "./FileDropZone.vue?vue&type=script&lang=js"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=9dde1226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dde1226",
  null
  
)

export default component.exports